import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => ({
  data: {
    type: 'paragraph--columns_item',
    id: createTemporaryEntityId(),
    attributes: {
      langcode: getEntityTemplateLang(),
      status: true,
      default_langcode: true,
    },
    relationships: {
      field_modules: {
        data: [],
      },
    },
    links: {},
    permissions: {
      update: true,
      create: true,
      delete: true,
    },
  },
  included: [],
});
